import e from"../helpers/isAbsoluteURL.js";import r from"../helpers/combineURLs.js";function o(o,s){return o&&!e(s)?r(o,s):s}export{o as default};
